// import { Api } from 'yxt-biz-pc-base';
// const { sspApi } = Api;
import { sspApi } from 'yxt-biz-pc/packages/api';
// 打赏组件-获取基本信息
export const getGratuityBaseInfo = (data) => {
  return sspApi.post('/point/reward/info', data);
};
// 打赏组件-打赏
export const postGratuity = (data) => {
  return sspApi.post('/point/reward/move', data);
};
